import { generateIconComponent } from './icons.utils';

export const ChevronUpLightIcon = generateIconComponent({
    name: 'ChevronUpLightIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M24 17.7342C24 18.0581 23.876 18.382 23.6306 18.63C23.1347 19.1233 22.3351 19.1233 21.8392 18.63L11.9991 8.7873L2.15893 18.63C1.66553 19.1233 0.863446 19.1233 0.370048 18.63C-0.123349 18.134 -0.123349 17.3345 0.370048 16.8385L11.1059 6.10271C11.3437 5.8674 11.6651 5.7333 11.9991 5.7333C12.3356 5.7333 12.6569 5.8674 12.8948 6.10271L23.6306 16.8385C23.876 17.0865 24 17.4104 24 17.7342Z" />
    ),
});
